import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Testimonial } from "./Testimonial";
import { DonationSummaryWithConfig } from "@/components/DonationSummary";
import { ImpactCalculatorWithConfig } from "@/components/ImpactCalculator";
import classes from "./DetailsLayout.module.scss";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTriggerMinimal,
} from "@/components/ui/Tabs";
import { useEffect, useRef, useState } from "react";
import { clsx } from "clsx";
import { useAppConfig } from "@/hooks/useAppConfig";
import { useNavigate } from "@/hooks/useNavigate";

export default function DetailsLayoutSidebar() {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [tab, setTab] = useState("summary");
  const { qoute } = useAppConfig();

  const { isFinalStep } = useNavigate();
  const hasBeenOpened = useRef(false);

  useEffect(() => {
    if (hasBeenOpened.current) return;

    if (isFinalStep) {
      setTab("summary");
      hasBeenOpened.current = true;
    }
  }, [isFinalStep]);

  if (isDesktop) {
    return (
      <div className={clsx(classes.sidebar, classes.sidebarGrid)}>
        <DonationSummaryWithConfig />

        <ImpactCalculatorWithConfig />

        <div className={classes.space} />

        <Testimonial quote={qoute} />
      </div>
    );
  }

  return (
    <div className={classes.sidebar}>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList align="start">
          <TabsTriggerMinimal value="summary">Summary</TabsTriggerMinimal>
          <TabsTriggerMinimal value="your-impact">
            Your Impact
          </TabsTriggerMinimal>
        </TabsList>
        <TabsContent value="summary">
          <DonationSummaryWithConfig collapsible />
        </TabsContent>
        <TabsContent value="your-impact">
          <div className={classes.sidebarGrid}>
            <ImpactCalculatorWithConfig />

            <Testimonial quote={qoute} />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
